module.exports = __webpack_public_path__ + "img/Phaseolus_vulgaris.c62ca7e1.jpg";